import { render } from "./LoadingNewsDetails.vue?vue&type=template&id=2f4b1fd8&scoped=true"
import script from "./LoadingNewsDetails.vue?vue&type=script&lang=js"
export * from "./LoadingNewsDetails.vue?vue&type=script&lang=js"

import "../../assets/css/loading/index.css?vue&type=style&index=0&id=2f4b1fd8&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4b1fd8"]])

export default __exports__